import React from "react";
import { PUBLIC } from "../config";

const sections = [
  { h: "What Nav is",     p: "Nav is a book on Robinhood Chain. Listed names sit next to their pools. New pairs come from the pads that already exist. Uniswap v2, v3, and v4 pairs live in the same book." },
  { h: "Listed names",    p: "A listed name is an official Stock Token. Each ticket carries two prices: pool and NAV. NAV is the oracle. Pool is what the AMM will fill." },
  { h: "Pool and NAV",    p: "Pool is the market. NAV is the reference. Δ is the difference. Small Δ is normal. Large Δ is a signal, not an alarm." },
  { h: "Session",         p: "RTH is regular trading hours. After hours still prints, at thinner depth. Halt disables buys. Nav does not decide the session; the listed venue does." },
  { h: "Official list",   p: "If it is not on the list, it is not that name. Copycat tickers are blocked before submit." },
  { h: "New pairs",       p: "New reads curves from pons.trade, hood.fun, and pools.trade. A deployer score is a heuristic, not a promise. Size after the line." },
  { h: "Ranges and Delta",p: "You draft a range in Nav. You fill it on Delta. Fees are estimates. Not financial advice." },
  { h: "Preview",         p: PUBLIC ? "Public access is open." : "Public access is not open. Features may change without notice. Nothing here is a solicitation." },
  { h: "Chain 4663",      p: "Robinhood Chain, chain ID 4663. Gas is paid in ETH. Quote and settlement default to USDG." },
];

export default function Docs() {
  return (
    <div style={{ maxWidth: 720, margin: "0 auto", padding: "48px 28px 40px" }}>
      <h1 className="serif" style={{ fontSize: 52, letterSpacing: "-0.02em", margin: "0 0 12px" }} data-testid="docs-title">
        Docs.
      </h1>
      <div style={{ color: "var(--ink-muted)", fontSize: 13, marginBottom: 32 }}>
        navearn.xyz · {PUBLIC ? "Reading from the chain." : "Preview · Reading from the chain."}
      </div>

      {sections.map((s, i) => (
        <section key={s.h} style={{ marginTop: 36, borderTop: i === 0 ? "none" : "1px solid var(--line)", paddingTop: i === 0 ? 0 : 24 }}>
          <h2 className="serif" style={{ fontSize: 24, letterSpacing: "-0.01em", margin: "0 0 10px" }}>{s.h}</h2>
          <p style={{ margin: 0, fontSize: 15.5, lineHeight: 1.6, color: "var(--ink)", maxWidth: "72ch" }}>{s.p}</p>
        </section>
      ))}
    </div>
  );
}
